import React from 'react';
import Hero from './components/exam-schedule/Hero';
import Main from './components/exam-schedule/Main';

const ExamSchedule = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default ExamSchedule;